import { Logs } from "./logs.js";
import isABTest from "../ab/isabtest.js";
import { isDesktop } from "react-device-detect";

export default class ExitPopUp {
  static exitBlockFunction = function () {
    Logs.AddEvent("Customer attempted to leave the site", false);
    Logs.SendEvents();
    // the text from the return is not used at all unless the customer is using an old browser
    return "Are you sure you want to leave?";
  };

  static Enable() {
    if (isDesktop && isABTest("CHEC-557-exit-popup-2")) {
      window.onbeforeunload = this.exitBlockFunction;
    }
  }

  static Disable() {
    window.onbeforeunload = null;
  }
}

